const styles = {
  filtersWrapper:
    'flex flex-col md:flex-row md:justify-between items-start md:items-center mb-5 md:mb-12',
  filterTiles: 'justify-start md:justify-end',
  divider: `w-full bg-gray-1 h-2px`,
  gridWrapper: 'pt-6 md:pt-12',
};

export default styles;
